import { EntityRequest } from "../entity/EntityRequest";
import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoRequestLoasGetRes } from "./abst/DtoRequestLoasGetRes";

export class DtoRequestLoasGetResImple extends DtoRequestLoasGetRes {
  public request = new EntityRequest();
  
  public pager = new DtoApiPager();
}
